import createReactClass from "create-react-class";
import React from "react";
import {
  Button,
  FormGroup,
  Glyphicon,
  MenuItem,
  Modal,
  Nav,
  Navbar,
  NavDropdown,
  NavItem,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { ServerActions } from "../actions/serverActions";
import { ServerAPI } from "../actions/serverAPI";
import { SlsActions } from "../actions/slsActions";
import CompareGisEnv from "../components/compareGisEnv";
import { SubdivisionView } from "../components/subdivision";
import CompareSub from "../components/compareSubdivision";
import GisEnv from "../components/gisEnv";
import Outage from "../components/outage";
import Territory from "../components/territory";
import User from "../components/user";
import Constants from "../constants/constants";
import { restrictionRequestStore } from "../stores/restrictionRequest";
import { slsStore } from "../stores/slsStore";
import { subdivisionStore } from "../stores/subdivision";
import { userStore } from "../stores/user";
import { withRouter } from "../util/withRouter";

function getStateFromStores() {
  return {
    selectedSubdivision: subdivisionStore.getSelectedSub(),
    schematicLoaded: restrictionRequestStore.isSchematicLoaded(),
    userRole: userStore.getUserRole(),
    selectedRole: userStore.getSelectedRole(),
    searchBy: slsStore.getSearchItemBy(),
  };
}

export const NavigationHeader = withRouter(
  createReactClass({
    componentDidMount: function () {
        ServerActions.getUserRole();
      subdivisionStore.subscribe(this._onChange);
      restrictionRequestStore.subscribe(this._onChange);
      userStore.subscribe(this._onChange);
      slsStore.subscribe(this._onChange);
    },

    componentWillUnmount: function () {
      subdivisionStore.unsubscribe(this._onChange);
      restrictionRequestStore.unsubscribe(this._onChange);
      userStore.unsubscribe(this._onChange);
      slsStore.unsubscribe(this._onChange);
    },

    getInitialState: function () {
      const storeState = getStateFromStores();
      return {
        showHelp: false,
        openAdmin: false,
        openPrint: false,
        ...storeState
      };
    },

    _onChange: function () {
      this.setState(getStateFromStores());
    },

    toggleAdminMenu: function (isOpen, e, { source }) {
      if (source === "rootClose" && e.target.id === "adminPageLinks") {
        return;
      }
      this.setState({ openAdmin: !!isOpen });
    },

    togglePrintMenu: function (isOpen, e, { source }) {
      if (
        source === "rootClose" &&
        ["printDropDown", "printIcon"].includes(e.target.id)
      ) {
        return;
      }
      this.setState({ openPrint: !!isOpen });
    },

    handleGuideClick: function () {
      ServerActions.downloadShowField();
    },

    toggleHelpModal() {
      this.setState({ showHelp: !this.state.showHelp });
    },

    closeHelp() {
      this.setState({ showHelp: false });
    },

    openHelp() {
      this.setState({ showHelp: true });
    },

    handleAPrint() {
      ServerActions.downloadFormAsPdf(
        this.state.selectedSubdivision,
        Constants.RestrictionTypes.A
      );
    },

    handleCPrint() {
      ServerActions.downloadFormAsPdf(
        this.state.selectedSubdivision,
        Constants.RestrictionTypes.C
      );
    },

    handleTCMPrint() {
      ServerActions.downloadFormAsPdf(
        this.state.selectedSubdivision,
        Constants.RestrictionTypes.TCM
      );
    },

    handleSchematicPrint() {
      ServerActions.downloadFormAsPdf(
        this.state.selectedSubdivision,
        Constants.RestrictionTypes.B
      );
    },

    handleFormBReqPrint() {
      ServerActions.downloadFormAsPdf(
        this.state.selectedSubdivision,
        Constants.RestrictionTypes.B,
        Constants.RestrictionStatuses.REQUESTED
      );
    },
    openUserPage() {
      ServerActions.openUsersAdminPage();
    },
    openPatternMaintenance() {
      ServerActions.openPatternMaintenance();
    },

    openOutagePage() {
      ServerActions.openOutageAdminPage();
    },

    openReasonCodePage() {
      ServerActions.openReasonCodeAdminPage();
    },

    openDefaultTrackAdminPage() {
      ServerActions.openDefaultTrackAdminPage();
    },

    handleHistoryRecord() {
      ServerActions.openHistoryPage(this.state.selectedSubdivision);
    },

    openOverridePage() {
      ServerActions.openOverridePage();
    },

    openComparePage() {
      ServerActions.openComparePage();
    },

    openSlsPage() {
      ServerActions.openSlsPage();
    },

    subRecalculate() {
      ServerActions.subRecalculate();
    },

    changeSearchBy(event) {
      var val = event.target.value;

      SlsActions.changeSearchBy(val);
    },

    itemFilter(value) {
      SlsActions.filterSlsItems(value.trim());
    },

    calculateGuidsForPushedItems() {
      var subName = { subdivision: this.state.selectedSubdivision };
      var serverCall = ServerAPI.calculateGuidsForPushedItems(subName);

      serverCall.done(function (data) {
        if (data.errors.length > 0) {
          console.log(data.errors[0].field, data.errors[0].message);
          alert(
            `Error while trying to calculate guids: ${data.errors[0].message}`
          );
        } else if (data.success) {
          console.log("Successfully Calculated Guids");

          if (data.data[1].length === 0) {
            alert(
              `Calculation Finished successful: All ${data.data[0].length} items updated successfully.`
            );
          } else {
            alert(
              `Calculation Finished: ${data.data[0].length} items updated successfully. The following items failed and did not get guids: ${data.data[1]}`
            );
          }
        } else {
          console.log("An error occurred while trying to calculate guids");
          alert(`Exception occurred while trying to calculate guids`);
        }
      });

      serverCall.fail(function (data) {
        console.log("Failed to calculate guids for pushed items", data);
        alert(`Exception occurred while trying to calculate guids`);
      });
    },

    render: function () {
      var helpModal = getHelpModal(
        this.state.showHelp,
        this.toggleHelpModal,
        this.handleGuideClick
      );

      var printLink = "";
      if (this.state.selectedSubdivision !== 0 && this.state.schematicLoaded) {
        printLink = (
          <NavDropdown
            noCaret
            id="printDropDown"
            title={<Glyphicon glyph="print" id="printIcon" />}
            eventKey={3}
            open={this.state.openPrint}
            onToggle={this.togglePrintMenu}
          >
            <MenuItem eventKey={3.1} onSelect={this.handleAPrint}>
              Form A
            </MenuItem>
            <MenuItem eventKey={3.2} onSelect={this.handleSchematicPrint}>
              Form B
            </MenuItem>
            <MenuItem eventKey={3.3} onSelect={this.handleFormBReqPrint}>
              Form B-Request
            </MenuItem>
            <MenuItem eventKey={3.4} onSelect={this.handleCPrint}>
              Form C
            </MenuItem>
            <MenuItem eventKey={3.5} onSelect={this.handleTCMPrint}>
              Form TCM
            </MenuItem>
          </NavDropdown>
        );
      }

      var links = [];
      var showAdmin = false;

      //If they are a grit admin, show all of the links
      if (this.state.userRole.indexOf(Constants.Roles.SLS_USER) > -1) {
        showAdmin = true;
        links.push(
          <MenuItem eventKey={3.2} onSelect={this.openUserPage}>
            Email Notifications
          </MenuItem>,
          <MenuItem eventKey={3.3} onSelect={this.openOutagePage}>
            Outage
          </MenuItem>,
          <MenuItem eventKey={3.4} onSelect={this.openReasonCodePage}>
            Reason Codes
          </MenuItem>,
          <MenuItem eventKey={3.5} onSelect={this.openDefaultTrackAdminPage}>
            Default Tracks
          </MenuItem>,
          <MenuItem eventKey={3.6} onSelect={this.openComparePage}>
            Compare
          </MenuItem>,
          <MenuItem eventKey={3.7} onSelect={this.openOverridePage}>
            Override
          </MenuItem>,
          <MenuItem eventKey={3.9} onSelect={this.openSlsPage}>
            SLS Items
          </MenuItem>,
          <MenuItem eventKey={3.1} onSelect={this.subRecalculate}>
            Subdivision Recalculate
          </MenuItem>
        );
      } else {
        //Else give links based on other permissions
        if (this.state.userRole.indexOf(Constants.Roles.SUPER_USER) > -1) {
          //If they are super user, show all of the admin links
          showAdmin = true;
          links.push(
            <MenuItem key={10} onSelect={this.openUserPage}>
              Email Notifications
            </MenuItem>,
            <MenuItem key={11} onSelect={this.openOutagePage}>
              Outage
            </MenuItem>,
            <MenuItem key={12} onSelect={this.openReasonCodePage}>
              Reason Codes
            </MenuItem>,
            <MenuItem key={13} onSelect={this.openDefaultTrackAdminPage}>
              Default Tracks
            </MenuItem>,
            // <MenuItem key={15} onSelect={this.openComparePage}>Compare</MenuItem>,

            <MenuItem key={16} onSelect={this.subRecalculate}>
              Subdivision Recalculate
            </MenuItem>
          );
        }

        if (
          this.state.userRole.indexOf(Constants.Roles.ADMIN) > -1 &&
          this.state.userRole.indexOf(Constants.Roles.SUPER_USER) === -1
        ) {
          //If they are admin, but not super user, just show the default tracks link
          showAdmin = true;
          links.push(
            <MenuItem key={17} onSelect={this.openDefaultTrackAdminPage}>
              Default Tracks
            </MenuItem>,
            // <MenuItem key={19} onSelect={this.openComparePage}>Compare</MenuItem>,
            <MenuItem key={20} onSelect={this.subRecalculate}>
              Subdivision Recalculate
            </MenuItem>
          );
        }

        // if (this.state.userRole.indexOf("grit-grant-override") > -1) {
        //   showAdmin = true;
        //   links.push(
        //     <MenuItem key={21} onSelect={this.openOverridePage}>Override</MenuItem>
        //   );
        // }
      }

      var historyTab = "";
      if (
        this.state.selectedSubdivision !== 0 &&
        this.state.selectedSubdivision !== "showall"
      ) {
        historyTab = (
          <MenuItem onSelect={this.handleHistoryRecord}>History</MenuItem>
        );
      }

      var readOnlyText = "";
      if (this.state.selectedRole.indexOf(Constants.Roles.READ_ONLY) === 0) {
        if (window.gritConfig.gritEnvironment === "prod") {
          readOnlyText = (
            <MenuItem>
              <span style={{ color: "red" }}>
                Read Only Access | Contact the MOW Help Desk to request access{" "}
              </span>
            </MenuItem>
          );
        } else {
          readOnlyText = (
            <MenuItem>
              <span style={{ color: "red" }}>Read Only Access</span>
            </MenuItem>
          );
        }
        showAdmin = false; //Make sure admin is blocked for read only users
      }
      var adminLinks = "";
      if (showAdmin) {
        adminLinks = (
          <NavDropdown
            open={this.state.openAdmin}
            onToggle={this.toggleAdminMenu}
            eventKey={1}
            id="adminPageLinks"
            title="Admin"
          >
            {links}
          </NavDropdown>
        );
      }

      var headerSelects = getHeaderDropDowns(
        this.props.location.pathname,
        helpModal,
        this,
        printLink,
        adminLinks,
        historyTab,
        readOnlyText
      );
      var headerTitle = getHeaderTitle(this.props.location.pathname);

      return (
        <div>
          <Navbar inverse fixedTop fluid>
            <Navbar.Header>
              <Navbar.Brand>
                <Link to="/" className="active">
                  <span
                    title={
                      "Build Version: " + window.gritConfig.gritVersionNumber
                    }
                  >
                    GRIT
                  </span>
                </Link>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            {headerTitle}
            {headerSelects}
          </Navbar>
          <div className="row">
            <Outage />
          </div>
          <div style={{ height: "100%" }}>{this.props.children}</div>
        </div>
      );
    },
  })
);

function getHelpModal(showHelp, closeHelp, handleGuideClick) {
  return (
    <Modal
      bsSize="large"
      dialogClassName="helpModal"
      onHide={closeHelp}
      show={showHelp}
    >
      <Modal.Header closeButton>
        <Modal.Title>Help</Modal.Title>
      </Modal.Header>

      <div className="modal-body">
        <u>Request Access:</u>
        <ul>
          <li>
            Non-dispatchers needing GRIT access, please email OPR DL GRIT
            Requests. Please include your employee ID in your request for
            access.
          </li>
        </ul>
        <u>Other issues:</u>
        <ul>
          <i>Non-dispatchers</i>
          <li>
            For technical issues contact the TSOC Transportation Help Desk at
            817-593-4357 option 3 option 1.
          </li>
        </ul>
        <ul>
          <i> Dispatchers</i>
          <li>For assistance, please contact the on duty System ACD.</li>
        </ul>

        <Button
          bsStyle="primary"
          id="openFieldGuideButton"
          onClick={handleGuideClick}
        >
          View Field GRIT Training Guide
        </Button>
      </div>
    </Modal>
  );
}

function getHeaderDropDowns(
  route,
  helpModal,
  navBar,
  printLink,
  adminLinks,
  historyTab,
  readOnlyText
) {
  var headerContents = "";
  switch (route) {
    case "/authgrantflowredirect":
    case "/signout":
    case "/restriction":
    case "/request":
    case "/":
      headerContents = (
        <Navbar.Collapse>
          <Navbar.Text>{getEnvironment()}</Navbar.Text>
          <Navbar.Form pullLeft style={{ marginTop: "15px" }}>
            <FormGroup>
              <Territory user={navBar.props.user} />
            </FormGroup>{" "}
            <FormGroup>
              <SubdivisionView user={navBar.props.user} />
            </FormGroup>{" "}
            <FormGroup>{getGisDropDown()}</FormGroup>
          </Navbar.Form>

          <Nav pullRight>
            {readOnlyText}
            {historyTab}
            {adminLinks}
            {printLink}
            <User user={navBar.props.user} />
            <NavItem onClick={navBar.toggleHelpModal}>
              Help <Glyphicon glyph="question-sign" />
              {helpModal}
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      );
      break;

    case "/compare":
      headerContents = (
        <Navbar.Collapse>
          <Navbar.Text>{getEnvironment()}</Navbar.Text>

          <Navbar.Form pullLeft style={{ marginTop: "15px" }}>
            <FormGroup>
              <CompareSub />
            </FormGroup>{" "}
            <FormGroup>{getCompareGisDropDown()}</FormGroup>
          </Navbar.Form>
          <Nav pullRight>
            {adminLinks}
            <User user={navBar.props.user} />
            <NavItem onClick={navBar.toggleHelpModal}>
              Help <Glyphicon glyph="question-sign" />
              {helpModal}
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      );
      break;

    case "/gritItems":
      headerContents = (
        <Navbar.Collapse>
          <Navbar.Text>{getEnvironment()}</Navbar.Text>
          <Navbar.Form pullLeft style={{ marginTop: "15px" }}>
            <FormGroup>
              <span style={{ color: "gray" }}>Search:</span>
              <select
                id="slsSearchSelect"
                value={navBar.state.searchBy}
                onChange={navBar.changeSearchBy}
              >
                <option key={0} value={"syncId"}>
                  Sync Id
                </option>
                <option key={1} value={"controlNumber"}>
                  Restr#
                </option>
                <option key={2} value={"subdivision"}>
                  Subdivision
                </option>
                <option key={3} value={"pendingAction"}>
                  Action
                </option>
                <option key={4} value={"tssReturnCode"}>
                  TSS Code
                </option>
                <option key={5} value={"type"}>
                  Type
                </option>
                <option key={6} value={"lastModifiedTimeStamp"}>
                  Last Modified
                </option>
              </select>
            </FormGroup>{" "}
            <FormGroup>
              <input
                type="text"
                onChange={(event) => navBar.itemFilter(event.target.value)}
              />
            </FormGroup>
          </Navbar.Form>
          <Nav pullRight>
            <User user={navBar.props.user} />
            <NavItem onClick={navBar.toggleHelpModal}>
              Help <Glyphicon glyph="question-sign" />
              {helpModal}
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      );
      break;

    default:
      headerContents = (
        <Navbar.Collapse>
          <Nav pullRight>
            {adminLinks}
            <User user={navBar.props.user} />
            <NavItem onClick={navBar.toggleHelpModal}>
              Help <Glyphicon glyph="question-sign" />
              {helpModal}
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      );
  }

  return headerContents;
}

function getHeaderTitle(route) {
  var headerTitle = "";
  switch (route) {
    case "/override":
      headerTitle = <Navbar.Text>Override</Navbar.Text>;
      break;
    case "/subRecalculate":
      headerTitle = <Navbar.Text>Subdivision Recalculate</Navbar.Text>;
      break;

    case "/compare":
      headerTitle = <Navbar.Text>Compare</Navbar.Text>;
      break;

    case "/gritItems":
      headerTitle = <Navbar.Text>All Items</Navbar.Text>;
      break;
  }

  return headerTitle;
}

function getEnvironment() {
  switch (window.gritConfig.gritEnvironment) {
    case "local":
      return (
        <span id="environment" style={{ color: "orange" }}>
          Local
        </span>
      );
    case "dev":
      return (
        <span id="environment" style={{ color: "green" }}>
          Development
        </span>
      );
    case "trial":
      return (
        <span id="environment" style={{ color: "yellow" }}>
          Trial
        </span>
      );
    case "test":
      return (
        <span id="environment" style={{ color: "blue" }}>
          Test
        </span>
      );
    case "qa":
      return (
        <span id="environment" style={{ color: "purple" }}>
          Training
        </span>
      );
    case "prod":
      return (
        <span id="environment" style={{ color: "red" }}>
          Production
        </span>
      );
    default:
      return (
        <span id="environment" style={{ color: "red" }}>
          Unknown - {window.gritConfig.gritEnvironment}
        </span>
      );
  }
}

function getGisDropDown() {
  switch (window.gritConfig.gritEnvironment) {
    case "local":
    case "dev":
      return <GisEnv />;
    case "trial":
    case "test":
    case "qa":
    case "prod":
    default:
      return "";
  }
}

function getCompareGisDropDown() {
  //Currently this drop down should be in all environments. This can be changed later if it needs to be restricted
  switch (window.gritConfig.gritEnvironment) {
    case "dev":
    case "trial":
    case "test":
    case "qa":
    case "prod":
    default:
      return <CompareGisEnv />;
  }
}
